import { TableIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const GridTable = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <TableIcon size={Sizes[size]} {...rest} color={fill} />;
};

GridTable.displayName = 'GridTable';
